import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSync, faImage } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './BannerData.css';
import NewBanner from '../NewBanner/NewBanner';

export default function BannerData() {
    const [banners, setBanners] = useState([]);

    useEffect(() => {
        cargarBanners();
    }, []);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`)
            .then(res => res.json())
            .then(data => setBanners(data.banner || []))
            .catch(err => console.error('Error al cargar banners:', err));
    };

    const eliminarBanner = (idBanner) => {
        Swal.fire({
            title: '¿Eliminar banner?',
            text: 'Este banner ya no se mostrará en la tienda principal.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/bannerDelete.php?idBanner=${idBanner}`, {
                    method: 'DELETE',
                })
                    .then(res => res.json())
                    .then(data => {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarBanners();
                    })
                    .catch(err => {
                        console.error('Error al eliminar banner:', err);
                        toast.error('Error al eliminar');
                    });
            }
        });
    };

    return (
        <div className="adminPageContainer">
            <ToastContainer />

            {/* Cabecera Principal */}
            <div className="adminHeaderSection">
                <div className="adminHeaderTitle">
                    <h2><FontAwesomeIcon icon={faImage} /> Banners Publicitarios</h2>
                    <p>Gestiona las imágenes promocionales destacadas que se muestran en la tienda.</p>
                </div>
                <div className="adminHeaderActions">
                    <NewBanner onBannerCreated={cargarBanners} />
                    <button className="adminActionBtn" onClick={cargarBanners} title="Recargar banners">
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                </div>
            </div>

            {/* Grilla de Banners */}
            <div className="bannersGridDisplay">
                {banners.length === 0 ? (
                    <div className="bannersEmptyState">
                        <FontAwesomeIcon icon={faImage} />
                        <h3>No hay banners registrados</h3>
                        <p>Agrega banners promocionales para promocionar tus mejores platos o promociones.</p>
                    </div>
                ) : (
                    banners.map(item => (
                        <div className="modernBannerCard" key={item.idBanner}>
                            <div className="bannerImgContainer">
                                <img src={item.imagen} alt="Banner promocional" />
                                <span className="bannerIdBadge">#{item.idBanner}</span>
                            </div>
                            <div className="bannerCardFooter">
                                <span className="bannerStateText">Activo en portada</span>
                                <button 
                                    className="btnTableAction btnBorrar"
                                    onClick={() => eliminarBanner(item.idBanner)}
                                    title="Eliminar este banner"
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
